<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import i18n from '@/plugins/i18n';
import {
  getLanguageOptions,
  parseAllowedLanguageCodesFromEnv,
  setCometLocale
} from '@/lib/cometLocale';

const { t, locale } = useI18n();
const router = useRouter();

const allowed = parseAllowedLanguageCodesFromEnv();

const items = computed(() =>
  getLanguageOptions(allowed, code => {
    const key = `languageSelector.names.${code}`;
    const translated = t(key);
    return translated === key ? code : translated;
  })
);

const currentLocale = computed(() =>
  typeof locale.value === 'string' ? locale.value : String(locale.value)
);

async function onSelect(code: string) {
  await setCometLocale(router, i18n, code);
}
</script>

<template>
  <v-select
    class="comet-i18n-exclude comet-language-select"
    data-testid="comet-language-selector"
    density="compact"
    hide-details
    variant="outlined"
    rounded="lg"
    prepend-inner-icon="mdi-earth"
    :aria-label="t('languageSelector.label')"
    :items="items"
    item-title="title"
    item-value="value"
    :model-value="currentLocale"
    @update:model-value="onSelect" />
</template>

<style scoped lang="scss">
.comet-language-select {
  max-width: 180px;
}
</style>
